
    import { computed, defineComponent, reactive, ref, watch, watchEffect, toRef,toRefs,defineAsyncComponent  } from "vue";
    import { useRouter, useRoute } from "vue-router";
    import { useStore } from "vuex";
    import demo from "./components/demo.vue" //静态引入
    // const demo = defineAsyncComponent(()=>import('./components/demo.vue')) //异步引入
    export default defineComponent({
        name: 'vue3Demo',
        components:{demo},
        // computed: {
        //     key() {
        //         return ''
        //     }
        // },
        // watch:{
            // vue2简易写法
           // num(newval,oldval){
           //   console.log('num变为'+newval)
           // },
            // vue2完整写法
            // num:{
            //    deep:true,
            //     handler(newval,oldval){
            //         console.log('num变为'+newval)
            //     },
            //     immediate:true,
            // }
        // },
        setup: function (props, context) {
            console.log(props, context)
            // 定义变量 ref    reactive
            let isShowDemo = ref(true)
            let name = ref('张三')
            let person: any = reactive({
                firstName: '李',
                lastName: '四',
                job: {
                    salary: 1000
                }
            })
            let num = ref(0)
            let msg = ref('你好啊')
            // 计算属性
            // 简写：（没有考虑计算属性被修改的情况）
            person.fullName = computed(() => {
                return person.firstName + '-' + person.lastName
            })
            // 完整写法（考虑读和写）
            person.fullName = computed({
                get() {
                    return person.firstName + '-' + person.lastName
                },
                set(value: any) {
                    const nameArr = value.split('-')
                    person.firstName = nameArr[0]
                    person.lastName = nameArr[1]
                }
            })
            //监听一 (ref定义的响应式数据 不要.value)
            // watch(num,(newval,oldval)=>{
            //     console.log('num变为'+newval)
            // },{immediate:true})
            // watch(msg,(newval,oldval)=>{
            //     console.log('num变为'+newval)
            // },{immediate:true})
            //监听二 多个ref定义的响应式数据
            // watch([num,msg],(newval,oldval)=>{
            //     console.log('监听的数据变为',newval)
            // },{immediate:true})
            //监听三 （reactive定义的响应式数据的全部属性）
            //注意一：newval和oldval始终一样，无法正确获得oldval
            //注意二：强制开启deep深度监视模式（deep配置无效 ）
            // watch(person,(newval,oldval)=>{
            //     console.log('person变了',newval, oldval)
            // },{immediate:true})
            //监听四 （reactive定义的响应式数据的某个属性）
            // watch(()=>person.firstName,(newval,oldval)=>{
            //     console.log('person变了',newval, oldval)
            // })
            //监听五 （reactive定义的响应式数据的某些属性）
            // watch([()=>person.firstName,()=>person.lastName],(newval,oldval)=>{
            //     console.log('person变了',newval, oldval)
            // })
            //监听六（reactive定义的响应式数据的对象属性,必须开启深度监视deep配置有效）
            // watch(()=>person.job,(newval,oldval)=>{
            //     console.log('person的工资变了',newval, oldval)
            // },{deep:true})

            //监听回调(默认开启immediate:true,回调函数用到了谁，监听谁，类似计算属性，区别：计算属性必须有返回值，watchEffect注重过程逻辑，可以不用return)
            watchEffect(() => {
                console.log('watchEffect启用了')
                const x1 = num.value
                const x2 = person.job.salary
                console.log('watchEffect回调执行')
            })
            // 定义方法
            let changeName = () => {
                name.value = '张三1'
                person.firstName = '李2'
                person.lastName = '四2'
            };
            let returnData = (data: string) => {
                console.log('回调触发父组件', data)
            }
            // 引入路由或者状态管理
            let router = useRouter()
            let route = useRoute()
            let store = useStore()
            // 使用router/route/store
            const toPage = () => { // 页面跳转
                router.push('/')
            }
            const id = route.query.id // 获取路由传参
            let state = reactive({
                isSidebarNavCollapse: computed(() => store.getters.getIsSidebarNavCollapse), // 计算属性
            });
            // 生命周期
            return {
                isShowDemo,
                name,
                person,
                lastName: toRef(person, "lastName"),
                ...toRefs(person),
                num,
                msg,
                changeName,
                returnData
            }
        },
    })
